import { Image } from "react-datocms";

export default function BlockPostImage({ record }) {
  return (
    <>
      {record && record.image && record.image.responsiveImage && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {record.linkUrl ? (
            <a href={record.linkUrl}>
              <Image
                client:visible
                lazyLoad={true}
                width="1200"
                data={record.image.responsiveImage}
                alt={record.image.alt || 'Image'}
                style={{
                  marginBottom: "30px",
                  marginTop: "30px",
                  width: record.image.customData?.width || "100%",
                  height: record.image.customData?.height || "auto",
                }}
              />
            </a>
          ) : (
            <Image
              client:visible
              lazyLoad={true}
              width="1200"
              data={record.image.responsiveImage}
              alt={record.image.alt || 'Image'}
              style={{
                marginBottom: "30px",
                marginTop: "30px",
                width: record.image.customData?.width || "100%",
                height: record.image.customData?.height || "auto",
              }}
            />
          )}
        </div>
      )}
    </>
  );
}